import { getBorderRadius } from 'Components/utils';

export default (theme) => ({
  root: {},
  imageCardContainer: {
    ...getBorderRadius(theme.radius.md, {
      bottomLeft: true,
      bottomRight: true,
    }),
    padding: theme.spacing(0, 2, 2, 2),
    backgroundColor: theme.palette.grey[200],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    maxWidth: theme.dimensions.md,
    height: theme.dimensions.md,
    margin: '0 auto',
  },
  imageCardContainerDesktop: {
    maxWidth: theme.dimensions.lg,
  },
  imageCardContent: {
    display: 'flex',
    height: '100%',
  },
  titleText: {},
  durationText: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  durationIcon: {
    marginRight: theme.spacing(1),
  },
  imageCardHeader: {
    padding: theme.spacing(0, 1),
    alignSelf: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  footer: {},
});
